import React from 'react';
import styled from 'styled-components';
import { usePromiseTracker } from 'react-promise-tracker';
import { RemoveScroll } from 'react-remove-scroll';

import { FloatingOverlay, FloatingPortal } from '@floating-ui/react';

import { zIndex } from '@ecp/common/src/style/constant';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Loading from '@ecp/common/src/components/progress/mo/Loading';

const LoadingSpinner = () => {
  const { promiseInProgress } = usePromiseTracker({ delay: 500 });

  return (
    <FloatingPortal>
      {promiseInProgress && (
        <RemoveScroll>
          <FloatingOverlay
            style={{
              display: 'grid',
              background: 'rgba(25, 25, 25, 0.65)',
              placeItems: 'center',
              zIndex: zIndex.spinner,
            }}
          >
            <FlexBoxColumn>
              <Loading />
              <Spacing top={20} />
              <StyledTextBox>{`페이지를 열고 있어요\n조금만 기다려주세요`}</StyledTextBox>
            </FlexBoxColumn>
          </FloatingOverlay>
        </RemoveScroll>
      )}
    </FloatingPortal>
  );
};

export default LoadingSpinner;

const StyledTextBox = styled(TextBox)`
  font-size: ${moTheme.font.size.$16};
  font-weight: 350;
  line-height: 25px;
  color: #ffffff;
  text-align: center;
`;
